import { BusinessPaymentsFail } from '../../../../components/service/business/BusinessPaymentsFail';
export const BusinessPaymentsFailPageView = () => {
  return <BusinessPaymentsFail data-sentry-element="BusinessPaymentsFail" data-sentry-component="BusinessPaymentsFailPageView" data-sentry-source-file="fail.tsx" />;
};